import { render, staticRenderFns } from "./OptionsAfterImportContactToCampaign.vue?vue&type=template&id=296c388b&scoped=true"
import script from "./OptionsAfterImportContactToCampaign.vue?vue&type=script&lang=js"
export * from "./OptionsAfterImportContactToCampaign.vue?vue&type=script&lang=js"
import style0 from "./OptionsAfterImportContactToCampaign.vue?vue&type=style&index=0&id=296c388b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c388b",
  null
  
)

export default component.exports